"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
const TableHead_1 = __importDefault(require("@mui/material/TableHead"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const ArrowUpward_1 = __importDefault(require("@mui/icons-material/ArrowUpward"));
const GetApp_1 = __importDefault(require("@mui/icons-material/GetApp"));
const Remove_1 = __importDefault(require("@mui/icons-material/Remove"));
const Edit_1 = __importDefault(require("@mui/icons-material/Edit"));
const Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
const QCheckbox_1 = __importDefault(require("components/QCheckbox"));
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const styles_1 = require("containers/NewReports/styles");
const utils_1 = require("./utils");
const TransactionRow_1 = __importDefault(require("./TransactionRow"));
const TABLE_COLUMN_WIDTHS = ['220px', '200px', '140px', '170px', '120px', '150px', '90px', '130px'];
const ItemizedTable = ({ incomeRows, expenseRows, overallTotal, view, isTransactionsView, maxDepth, sortBy, sortDirection, hasUserSorted, expandedKeys, selectedTxns, visibleTxns, tagsById, checkboxSize, palette, classes, cx, getAccountName, getTxnAmountForRow, onHeaderSort, onToggleExpanded, onToggleTxnSelected, onToggleSelectAllVisible, onShowBulkEdit, onBulkDelete, onExportSelectedCsv, selectedTotal, }) => {
    const areAllVisibleSelected = react_1.default.useMemo(() => visibleTxns.size > 0 && visibleTxns.every((txn) => selectedTxns.has(txn)), [selectedTxns, visibleTxns]);
    const isAnyVisibleSelected = react_1.default.useMemo(() => visibleTxns.some((txn) => selectedTxns.has(txn)), [selectedTxns, visibleTxns]);
    const renderSortableHeader = (label, field, align = 'left') => {
        const isActive = sortBy === field;
        const showIcon = hasUserSorted && isActive;
        return (<Box_1.default display="inline-flex" alignItems="center" justifyContent={align === 'center' ? 'center' : 'flex-start'} onClick={() => {
                if (isTransactionsView) {
                    onHeaderSort(field);
                }
            }} sx={{ cursor: isTransactionsView ? 'pointer' : 'default' }}>
        <Typography_1.default className={classes.sortLabel} component="span">
          {label}
        </Typography_1.default>
        {showIcon ? (<ArrowUpward_1.default sx={{
                    ml: 0.5,
                    fontSize: 18,
                    transform: sortDirection === 'desc' ? 'rotate(180deg)' : 'none',
                }}/>) : null}
      </Box_1.default>);
    };
    const renderSection = (title, rows, sectionKey) => {
        var _a;
        const sectionTotal = rows
            .filter((row) => row.depth === 0)
            .reduce((total, row) => total + (row.total || 0), 0);
        const showExpanded = (_a = expandedKeys[sectionKey]) !== null && _a !== void 0 ? _a : true;
        const headerCellClassName = cx(classes.groupHeaderCell, sectionKey === 'expenses' && classes.groupHeaderCellWithTopBorder);
        return (<>
        <TableRow_1.default key={`${sectionKey}-header`}>
          <styles_1.StickyTableCellLeft className={headerCellClassName} sx={{ p: 0 }}>
            <Typography_1.default variant="subtitle2" className={classes.groupHeaderText} sx={{ display: 'flex', alignItems: 'center' }}>
              <IconButton_1.default onClick={(event) => {
                event.stopPropagation();
                onToggleExpanded(sectionKey, true);
            }} sx={{ py: 0 }}>
                {showExpanded ? <Remove_1.default /> : <Add_1.default />}
              </IconButton_1.default>
              {title}
            </Typography_1.default>
          </styles_1.StickyTableCellLeft>
          <TableCell_1.default colSpan={6} className={headerCellClassName}/>
          <styles_1.StickyTableCellRight align="center" className={headerCellClassName}>
            <Typography_1.default variant="subtitle2" className={classes.groupHeaderText}>
              {sectionTotal.toFixed(2)}
            </Typography_1.default>
          </styles_1.StickyTableCellRight>
        </TableRow_1.default>

        {showExpanded &&
                (() => {
                    const rendered = [];
                    let depthOpen = [];
                    let lastRendered = null;
                    const pushTxnRows = (row, key, displayIndent, isExpanded) => {
                        if (!isExpanded || !row.txns || row.txns.size === 0)
                            return;
                        const txnIndent = displayIndent + 30;
                        (0, utils_1.sortTxns)(row.txns, sortBy, sortDirection, tagsById, (txn) => getTxnAmountForRow(txn, row)).forEach((txn) => {
                            const txnId = txn.id || '';
                            rendered.push(<TransactionRow_1.default key={`${key}-txn-${txnId}`} txn={txn} rowKey={key} txnIndent={txnIndent} amount={getTxnAmountForRow(txn, row)} isSelected={selectedTxns.has(txn)} checkboxSize={checkboxSize} categoryId={row.categoryId} getAccountName={getAccountName} onToggleSelect={onToggleTxnSelected} tagsById={tagsById} classes={classes}/>);
                        });
                    };
                    rows.forEach((row) => {
                        var _a, _b, _c, _d;
                        depthOpen = depthOpen.slice(0, row.depth);
                        const parentExpanded = row.depth === 0 ? true : (_a = depthOpen[row.depth - 1]) !== null && _a !== void 0 ? _a : true;
                        if (!parentExpanded) {
                            depthOpen[row.depth] = false;
                            return;
                        }
                        const key = `${sectionKey}-${row.categoryId || row.groupKey}-${row.depth}`;
                        const hasChildren = Array.isArray(row.subgroups) && row.subgroups.length > 0;
                        const hasVisibleChildren = hasChildren && row.depth < maxDepth;
                        const hasTxnRows = Boolean(row.txns && row.txns.size > 0);
                        const canExpandLeafTxns = !hasVisibleChildren && hasTxnRows;
                        let isExpanded = (_b = expandedKeys[key]) !== null && _b !== void 0 ? _b : view !== 'top';
                        if (canExpandLeafTxns) {
                            isExpanded = (_c = expandedKeys[key]) !== null && _c !== void 0 ? _c : isTransactionsView;
                        }
                        if (view === 'category' && row.leafParent) {
                            isExpanded = (_d = expandedKeys[key]) !== null && _d !== void 0 ? _d : false;
                        }
                        depthOpen[row.depth] = isExpanded;
                        const displayIndent = 16 + 20 * row.depth;
                        const isDuplicateLabel = lastRendered && row.depth === lastRendered.depth + 1 && row.groupKey === lastRendered.groupKey;
                        if (isDuplicateLabel && !hasVisibleChildren) {
                            pushTxnRows(row, key, displayIndent, parentExpanded);
                            lastRendered = { groupKey: row.groupKey, depth: row.depth };
                            return;
                        }
                        rendered.push(<react_1.default.Fragment key={key}>
                  <TableRow_1.default hover onClick={() => {
                                if (hasChildren || canExpandLeafTxns) {
                                    onToggleExpanded(key, isExpanded);
                                }
                            }} sx={{ cursor: hasVisibleChildren || canExpandLeafTxns ? 'pointer' : 'default' }} className={classes.categoryRow}>
                    <styles_1.StickyTableCellLeft sx={{ p: 0 }}>
                      <Box_1.default display="flex" alignItems="center" pl={`${displayIndent}px`}>
                        <Box_1.default width={24}/>
                        <Box_1.default width={24}>
                          {(hasVisibleChildren || canExpandLeafTxns) && (<IconButton_1.default size="small" onClick={(event) => {
                                    event.stopPropagation();
                                    onToggleExpanded(key, isExpanded);
                                }}>
                              {isExpanded ? <Remove_1.default fontSize="small"/> : <Add_1.default fontSize="small"/>}
                            </IconButton_1.default>)}
                        </Box_1.default>
                        <Typography_1.default noWrap className={row.depth <= 1 ? classes.rowKeyText : undefined} sx={{ minWidth: 0 }}>
                          {row.groupKey || 'Unnamed'}
                        </Typography_1.default>
                      </Box_1.default>
                    </styles_1.StickyTableCellLeft>
                    <TableCell_1.default colSpan={6}/>
                    <styles_1.StickyTableCellRight align="center">
                      <Typography_1.default className={classes.amountText}>{(row.total || 0).toFixed(2)}</Typography_1.default>
                    </styles_1.StickyTableCellRight>
                  </TableRow_1.default>
                </react_1.default.Fragment>);
                        if (!hasVisibleChildren) {
                            pushTxnRows(row, key, displayIndent, isExpanded);
                        }
                        lastRendered = { groupKey: row.groupKey, depth: row.depth };
                    });
                    return rendered;
                })()}
      </>);
    };
    return (<>
      {selectedTxns.size > 0 && (<div className={classes.selectionBar}>
          <QIconButton_1.default aria-label="Edit selected transactions" id="itemized_bulk_edit" IconComponent={Edit_1.default} onClick={onShowBulkEdit} tooltip="Bulk edit all selected transactions at once" size="small-target"/>
          <QIconButton_1.default aria-label="Delete selected transactions" id="itemized_bulk_delete" IconComponent={Delete_1.default} onClick={onBulkDelete} tooltip="Delete all selected transactions" size="small-target"/>
          <QIconButton_1.default aria-label="Download a CSV file with all selected transactions" id="itemized_bulk_download" IconComponent={GetApp_1.default} onClick={onExportSelectedCsv} tooltip="Download a CSV file with all selected transactions" size="small-target"/>
          <Typography_1.default variant="subtitle2" className={classes.selectionText}>
            {selectedTxns.size} Transaction{selectedTxns.size > 1 ? 's' : ''} Selected ({selectedTotal.toFixed(2)})
          </Typography_1.default>
        </div>)}

      <TableContainer_1.default className={cx(classes.tableOuter, selectedTxns.size > 0 && classes.tableOuterWithSelection)} sx={{ maxHeight: selectedTxns.size > 0 ? 'calc(100vh - 340px)' : 'calc(100vh - 260px)', overflowY: 'auto' }}>
        <Table_1.default stickyHeader aria-label="itemized transactions table" sx={{ borderCollapse: 'separate', borderSpacing: 0, tableLayout: 'auto', width: '100%' }}>
          <colgroup>
            {TABLE_COLUMN_WIDTHS.map((width) => (<col key={width} style={{ width }}/>))}
          </colgroup>
          <TableHead_1.default>
            <TableRow_1.default className={classes.headRow}>
              <styles_1.StickyTableCellLeft className={cx(classes.headCell, selectedTxns.size === 0 && classes.headCellFirst)}>
                <Box_1.default display="flex" alignItems="center" justifyContent="start" gap={1} pl={7}>
                  <Box_1.default className={classes.checkboxCompactWrapper}>
                    <QCheckbox_1.default size={checkboxSize} checked={areAllVisibleSelected} indeterminate={isAnyVisibleSelected && !areAllVisibleSelected} disabled={visibleTxns.size === 0} onClick={(event) => {
            event.stopPropagation();
            onToggleSelectAllVisible();
        }}/>
                  </Box_1.default>
                  {renderSortableHeader('Date', 'date')}
                </Box_1.default>
              </styles_1.StickyTableCellLeft>
              <TableCell_1.default className={classes.headCell} sx={{ width: TABLE_COLUMN_WIDTHS[1] }}>
                Account
              </TableCell_1.default>
              <TableCell_1.default className={classes.headCell} sx={{ width: TABLE_COLUMN_WIDTHS[2] }}>
                {renderSortableHeader('Check #', 'num')}
              </TableCell_1.default>
              <TableCell_1.default className={classes.headCell} sx={{ width: TABLE_COLUMN_WIDTHS[3] }}>
                {renderSortableHeader('Payee', 'description')}
              </TableCell_1.default>
              <TableCell_1.default className={classes.headCell} sx={{ width: TABLE_COLUMN_WIDTHS[4] }}>
                {renderSortableHeader('Memo', 'memo')}
              </TableCell_1.default>
              <TableCell_1.default className={classes.headCell} sx={{ width: TABLE_COLUMN_WIDTHS[5] }}>
                {renderSortableHeader('Tag', 'tag')}
              </TableCell_1.default>
              <TableCell_1.default className={classes.headCell} sx={{ width: TABLE_COLUMN_WIDTHS[6], textAlign: 'center' }}>
                {renderSortableHeader('Clr', 'clr', 'center')}
              </TableCell_1.default>
              <styles_1.StickyTableCellRight className={cx(classes.headCell, selectedTxns.size === 0 && classes.headCellLast)} sx={{ width: TABLE_COLUMN_WIDTHS[7], textAlign: 'center' }}>
                {renderSortableHeader('Amount', 'amount', 'center')}
              </styles_1.StickyTableCellRight>
            </TableRow_1.default>
          </TableHead_1.default>
          <TableBody_1.default>
            {incomeRows.length > 0 && renderSection('Income', incomeRows, 'income')}
            {incomeRows.length > 0 && expenseRows.length > 0 && (<TableRow_1.default>
                <TableCell_1.default colSpan={8} sx={{ height: 16, p: 0, borderBottom: 'none', backgroundColor: 'transparent' }}/>
              </TableRow_1.default>)}
            {expenseRows.length > 0 && renderSection('Expenses', expenseRows, 'expenses')}
            <TableRow_1.default sx={{ '& > *': { borderTop: `1px solid ${palette.divider}` } }}>
              <styles_1.StickyTableCellLeft className={classes.tableBgCell}/>
              <TableCell_1.default colSpan={6} align="right" className={classes.tableBgCell}>
                <Typography_1.default variant="subtitle2" fontSize={16}>Overall Total</Typography_1.default>
              </TableCell_1.default>
              <TableCell_1.default align="center" className={classes.tableBgCell}>
                <Typography_1.default variant="subtitle2" fontSize={16}>
                  {overallTotal.toFixed(2)}
                </Typography_1.default>
              </TableCell_1.default>
            </TableRow_1.default>
          </TableBody_1.default>
        </Table_1.default>
      </TableContainer_1.default>
    </>);
};
exports.default = ItemizedTable;
